var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiGenerateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.311 43.6894L66.9999 47.0353L60.311 50.3912L56.9678 57.0679L53.6246 50.3912L46.9357 47.0353L53.6246 43.6894L56.9678 37.0026L60.311 43.6894ZM23.5284 20.376L16.8395 17.0326L23.5284 13.6893L26.8716 7L30.2148 13.6893L36.9036 17.0326L30.2148 20.376L26.8716 27.0653L23.5284 20.376ZM55.295 18.7056L49.4437 15.7786L55.295 12.8515L58.2218 7L61.1487 12.8515L66.9999 15.7786L61.1487 18.7056L58.2218 24.5571L55.295 18.7056Z",
    fill: "#009980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00106 59.4485C6.96646 57.4571 7.70627 55.5301 9.06457 54.0736L29.6713 33.4626L40.6276 44.2367L19.9243 64.9364C18.4675 66.2945 16.5404 67.0339 14.5492 66.9988C12.558 66.9637 10.6581 66.157 9.25004 64.7485C7.84196 63.34 7.03566 61.4399 7.00106 59.4485Z",
    fill: "#009980"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7832 23.669L50.3296 29.2157C51.7989 30.6851 51.7987 33.0674 50.3293 34.5366L43.5049 41.3598L32.5576 30.5757L39.4626 23.6692C40.9318 22.1997 43.3139 22.1997 44.7832 23.669Z",
    fill: "#009980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiGenerateIcon);
export default __webpack_public_path__ + "static/media/AiGenerateIcon.6842be334057fb35bde599e2468a7ef2.svg";
export { ForwardRef as ReactComponent };